/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GenerateSOffenderRecordsReport200ResponseData } from './GenerateSOffenderRecordsReport200ResponseData';
import {
    GenerateSOffenderRecordsReport200ResponseDataFromJSON,
    GenerateSOffenderRecordsReport200ResponseDataFromJSONTyped,
    GenerateSOffenderRecordsReport200ResponseDataToJSON,
} from './GenerateSOffenderRecordsReport200ResponseData';

/**
 * 
 * @export
 * @interface GenerateSOffenderRecordsReport200Response
 */
export interface GenerateSOffenderRecordsReport200Response {
    /**
     * 
     * @type {GenerateSOffenderRecordsReport200ResponseData}
     * @memberof GenerateSOffenderRecordsReport200Response
     */
    data?: GenerateSOffenderRecordsReport200ResponseData;
}

/**
 * Check if a given object implements the GenerateSOffenderRecordsReport200Response interface.
 */
export function instanceOfGenerateSOffenderRecordsReport200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GenerateSOffenderRecordsReport200ResponseFromJSON(json: any): GenerateSOffenderRecordsReport200Response {
    return GenerateSOffenderRecordsReport200ResponseFromJSONTyped(json, false);
}

export function GenerateSOffenderRecordsReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateSOffenderRecordsReport200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : GenerateSOffenderRecordsReport200ResponseDataFromJSON(json['data']),
    };
}

export function GenerateSOffenderRecordsReport200ResponseToJSON(value?: GenerateSOffenderRecordsReport200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GenerateSOffenderRecordsReport200ResponseDataToJSON(value.data),
    };
}

